<!--  -->
<template>
  <div class="noteTitle">
    <span v-if="titleShow&&title!=''" style="color:#97a8be">《{{title}}》</span>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    name: "noteTitle"
  },
  data() {
    //这里存放数据
    return {
      title:'',
      titleShow:false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    $route() {
      this.getTitle()
    },
    // title(){
    //   console.log("间听到了")
    //   this.getTitle()
    // },
    // title(val, oldVal){//普通的watch监听
    //      console.log("标题: "+val, oldVal);
    //  },
     title:{//深度监听，可监听到对象、数组的变化
         handler(val, oldVal){
             console.log("标题: "+val, oldVal);
         },
         deep:true //true 深度监听
     },
  },
  //方法集合
  methods: {
    getTitle(){
       if(this.$route.path.indexOf("dataInfoCheck") != "-1"&&this.$route.query.come=='1'||this.$route.path.indexOf("dataInfoTiled") != "-1"){
          // console.log("是校对页面 存在")
          this.titleShow=true;
        }else{
          // console.log("不是校对页面 不存在")
          this.titleShow=false;
        }
        var noteTitle=sessionStorage.getItem('NoteTitle')
        if(noteTitle){
          this.title=noteTitle;
          
        }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getTitle();
    
   
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>
<style scoped>
.noteTitle{
      float: left;
    line-height: 50px;
    font-size: 14px;
    margin-left: 15px;
}
</style>